import * as React from 'react';

import { translate } from '~l10n/client';
import { Badge } from '~shared/components/Badge';
import { Link } from '~shared/components/Link';
import type { LinkProps } from '~shared/components/Link';
import {
  TeacherApplicationContext,
  useTeacherApplicationContext,
} from '~shared/context/TeacherApplicationContext';

import { LearnMoreIcon } from './GenerateQuestionDialog/LearnMoreIcon';

const helpLinks: Record<TeacherApplicationContext, string> = {
  [TeacherApplicationContext.ShowbieAssessments]:
    'https://support.showbie.com/en/articles/13779987-showbie-ai-overview',
  [TeacherApplicationContext.Socrative]:
    'https://help.socrative.com/en/articles/13639049-socrative-ai-overview',
};

type AiAssistedBadgeLinkProps = Pick<LinkProps, 'onClick'>;

export function AiAssistedBadgeLink({ onClick }: AiAssistedBadgeLinkProps) {
  const context = useTeacherApplicationContext();

  return (
    <Link
      href={helpLinks[context]}
      target="_blank"
      rel="noopener noreferrer"
      className="no-underline"
      indicatorProps={{ isInset: false, notOffset: true }}
      onClick={onClick}
    >
      <Badge textTransform="capitalize" tone="ai">
        {translate('AI Assisted')}
        <LearnMoreIcon />
      </Badge>
    </Link>
  );
}
